import { Outlet, useLocation } from 'react-router-dom';

import { EmergencyBar } from '@/components/emergency-bar';
import { useRouteMeta } from '@/hooks/use-route-meta';

import { Footer } from './footer';
import { Header } from './header';

const emergencyRoutes = ['/', '/baumpflege/sturmschaeden', '/baumfaellung/notfaellung'];

export function RootLayout(): React.ReactNode {
  const { pathname } = useLocation();
  useRouteMeta();
  const showEmergency = emergencyRoutes.includes(pathname);

  return (
    <div className="flex min-h-screen flex-col">
      <a className="skip-link" href="#main">
        Zum Inhalt springen
      </a>
      {showEmergency ? <EmergencyBar /> : null}
      <Header />
      <main id="main" className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
